/**
 * Mutliple Tab solution:
 * Save static data to the local storage
 * Link will Open a new tab and the app.component.ts will get the local storage session data
 * Apply to new tab session and delete local storage.
 * Deleteing local storage directly after will preven data popllution.
 * 
 * What about session expired in on tab and not the other?
 * Solution 1: Make a service that checks session service when the five minute mark is hit.
 * Solution 2: Wait for the APi to log you out of the session
 */
import { Injectable }    from '@angular/core';

const localPreFix = 'mwp-lst-';

@Injectable()
export class LocalStorageService {
    constructor(){
    }

    public store<T>(storeKey: string, object: T): void {
        localStorage.setItem(`${localPreFix}${storeKey}`, JSON.stringify(object));
    }

    public retrieve(storeKey: string): any {
        return JSON.parse(localStorage.getItem(`${localPreFix}${storeKey}`));
    }

    public clear(): void {
        localStorage.clear();
    }
}